import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { WorkflowStep } from '@warema/shared/models';

@Component({
    selector: 'warema-wizard-steps',
    imports: [],
    templateUrl: './wizard-steps.component.html',
    styleUrls: ['./wizard-steps.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WizardStepsComponent {
    public readonly workflowStepChanged = output<WorkflowStep>();
    public readonly steps = input<Array<WorkflowStep>>([]);
    public readonly activatedStep = input<WorkflowStep | null>(null);
    public readonly previouslyActivatedStep = input<WorkflowStep | null>(null);

    public arePreviousStepsValid(position: number): boolean {
        return !this.steps()
            .slice(0, position)
            .some(x => !x.isValid || null);
    }
}
